import React, { useEffect, useState } from 'react'
import { Layout } from '../../../../components/layout'
import { FsnStats } from '../../../../api/fsn-stats'
import '../../../../css/typography-avenir-next.css'

import liveScoreBg from '../../../../images/turbotax/april/tijuana_vs_atletico_san_luis/300x250.jpg'
import { StringParam, useQueryParam } from 'use-query-params'

const styles = {
  div: {
    background: `url(${liveScoreBg}) no-repeat`,
    boxSizing: 'border-box',
    height: '250px',
    width: '300px',
    position: 'relative',
  },
  timeContainer: {
    justifyContent: 'center',
    position: 'absolute',
    top: '160px',
    width: '300px',
    height: '50px',
    display: 'flex',
    fontFamily: 'AvenirNext Demi',
    fontWeight: 'bold',
    time: {
      display: 'block',
      width: '50px',
      height: '50px',
      textAlign: 'center',
      fontSize: '30px',
      color: '#FFF',
      lineHeight: '50px',
    },
  },
  liveContainer: {
    position: 'absolute',
    top: '62px',
    left: '163px',
    width: '100px',
    fontFamily: 'AvenirNext Demi',
    fontWeight: 'bold',
    liveScores: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      height: '53px',
      textAlign: 'center',
      fontSize: '28px',
      color: '#FFF',
      lineHeight: '28px',
      gap: '10px',
    },
    liveTime: {
      display: 'flex',
      gap: '1px',
      justifyContent: 'center',
      width: '100%',
      lineHeight: '20px',
      textAlign: 'center',
      color: '#FFF',
      position: 'relative',
      left: '0px',
      top: '9px',
      time: {
        display: 'block',
        height: '12px',
        lineHeight: '12px',
        textAlign: 'center',
        fontSize: '12px',
        color: '#FFF',
      },
    },
  },
}

export default function MatchUCHWidget() {
  const [api] = useState(new FsnStats())
  const [site = 'BUS'] = useQueryParam('site', StringParam)
  const [matchScores, setMatchScores] = useState({
    length_minutes: 0,
    length_seconds: 0,
    total_scores_away: 0,
    total_scores_home: 0,
  })
  useEffect(() => {
    let interval = null

    const getMatch = async () => {
      try {
        const match = await api.getMatch({
          matchId: 'ec6b1ec2-9a67-495f-931d-50513f942e00',
          site,
        })

        const {
          length_minutes,
          length_seconds,
          total_scores_away,
          total_scores_home,
        } = match

        setMatchScores({
          length_minutes,
          length_seconds,
          total_scores_away,
          total_scores_home,
        })
      } catch (e) {
        console.log(e)
      }
    }
    getMatch()

    interval = setInterval(getMatch, 60000)

    return () => {
      interval && clearInterval(interval)
    }
  }, [])

  return (
    <Layout>
      <div style={{ ...styles.div }}>
        <div
          style={{
            ...styles.liveContainer,
          }}
        >
          <div style={styles.liveContainer.liveScores}>
            <span>{matchScores.total_scores_home ?? '0'}</span>
            <span>-</span>
            <span>{matchScores.total_scores_away ?? '0'}</span>
          </div>

          <div style={styles.liveContainer.liveTime}>
            <span style={styles.liveContainer.liveTime.time}>
              {matchScores.length_minutes < 10 && '0'}
              {matchScores.length_minutes ?? '0'}
            </span>

            <span
              style={{ ...styles.liveContainer.liveTime.time, width: 'auto' }}
            >
              :
            </span>

            <span style={styles.liveContainer.liveTime.time}>
              {matchScores.length_seconds < 10 && '0'}
              {matchScores.length_seconds ?? '0'}
            </span>
          </div>
        </div>
      </div>
    </Layout>
  )
}
